import Country from '~/Api/Country/Country';

export default class ReferenceBasketVersion {
	id: string;

	description: string;

	sinceDate: Date;

	referenceCountries: Country[];

	constructor(id: string, description: string, sinceDate: Date, referenceCountries: Country[]) {
		this.id = id;
		this.description = description;
		this.sinceDate = sinceDate;
		this.referenceCountries = referenceCountries;
	}
}
